let organisations_ajax = require( './organisations-ajax' );

let account_details_form = (function( $ ) {

	let $form;

	let init = function( form_selector ) {
		$form = $( form_selector );

		if ( $form.length > 0 ) {
			_setup_practices_lazy_load();
			setup_form_triggers();

			$form.trigger( 'saved' );

			let $practice_lookup = $( '#field_practice_lookup' );
			if ( $practice_lookup.val() ) {
				$practice_lookup.trigger( 'change' );
			}

			let $address_type = $('#field_address_type');

			_toggle_address_description( $address_type.val() === 'practice_lookup' ? 'practice' : 'personal' );
		}
	};

	let _show_practice_lookup_link_toggle = function() {
		let $link = $( '#enable-practice-lookup' );

		if ( $link.length > 0 ) {
			$link.slideDown( 300 );
		}
	};

	let _hide_practice_lookup_link_toggle = function() {
		let $link = $( '#enable-practice-lookup' );

		if ( $link.length > 0 ) {
			$link.slideUp( 300 );
		}
	};

	let _clear_practice_code = function() {
		let $select = $form.find( 'select#field_practice_lookup' );

		$select.val( '' );
		$select.trigger( 'change' );
	};

	let _clear_employer = function() {
		let $select = $form.find( 'select#field_employer' );

		$select.val( '' );
		$select.trigger( 'change' );
	};

	let _clear_gp_role = function() {
		let $select = $form.find( 'select#field_gp_role' );

		$select.val( '' );
		$select.trigger( 'change' );
	};

	let _setup_practices_lazy_load = function() {
		let $select = $form.find( 'select#field_practice_lookup' );

		$select.select2({
			dropdownParent: $select.closest( '.field-wrap' ),
			ajax: {
				url : ScriptData.ajaxurl,
				method: 'POST',
				dataType : 'json',
				delay : 250,
				data : organisations_ajax.get_select2_options
			}
		});
	};

	let setup_form_triggers = function() {
		$form.on( 'personal_address', function( e ) {
			_toggle_address_description( 'personal' );
		} );

		$form.on( 'practice_address practice_lookup pre_practice_lookup', function( e ) {
			_toggle_address_description( 'practice' );
		} );

		$form.on( 'close_addresses', function( e ) {
			_toggle_address_description( 'closed' );
		} );

		$form.on( 'disable_address_fields', function( e ) {
			_disable_address_fields();
		} );

		$form.on( 'enable_address_fields', function( e ) {
			_enable_address_fields();
		} );

		_setup_role_change_event();

		_setup_practice_select_manual();

		_setup_practice_address_autofill();

		_setup_practice_lookup_link();
	};

	let _setup_practice_lookup_link = function() {
		let $link = $( '#enable-practice-lookup' );

		if ( $link.length > 0 ) {
			$link.on( 'click', ( e ) => {
				e.preventDefault();
				_update_address_type( 'practice_lookup', 'click' );
				_clear_manual_address_fields();
				_disable_address_fields();
			} );
		}
	};

	let _setup_role_change_event = function() {
		$form.find( 'select#field_occupation' ).on( 'change', function( e ) {
			if ( $( this ).val() === 'locum' ) {
				_clear_practice_code();
			}

			_clear_employer();
			_clear_gp_role();
			_update_address_type( $( this ).val(), 'occupation' );
		} );

		$form.find( 'select#field_gp_role' ).on( 'change', function( e ) {
			if ( $( this ).val() === 'locum' ) {
				_clear_practice_code();
			}

			_update_address_type( $( this ).val(), 'gp_role' );
		} );

		$form.find( 'select#field_employer' ).on( 'change', function( e ) {
			if ( $( this ).val() === 'not_employed' ) {
				_clear_practice_code();
			}

			_update_address_type( $( this ).val(), 'employer' );
		} );

		$form.find( '#manually-insert-practice-details' ).on( 'click', function( e ) {
			e.preventDefault();

			_clear_practice_code();

			$form.find( 'select#field_practice_lookup' ).select2( 'close' );

			_update_address_type( 'practice_manual', 'click' );

			$form.trigger( 'enable_address_fields' );
		} );
	};

	let _update_address_type = function( value, change ) {
		let $field = $( '#field_address_type' );

		change = change ? change : '';

		if ( $field.val() === 'practice_manual' && value !== 'practice_manual' ) {
			_hide_practice_lookup_link_toggle();
		}

		if ( change === 'occupation' ) {
			if ( value === 'locum' ) {
				$field.val( 'personal' );

				$form.trigger( 'personal_address' );
			} else {
				$field.val( '' );

				$form.trigger( 'close_addresses' );
			}
		} else if ( change === 'gp_role' ) {
			if ( value === 'locum' ) {
				$field.val( 'personal' );

				$form.trigger( 'personal_address' );
			} else if ( value === 'partner' || value === 'salaried' ) {
				$field.val( 'practice_lookup' );

				$form.trigger( 'practice_lookup' );
			} else {
				$field.val( '' );

				$form.trigger( 'close_addresses' );
			}
		} else if ( change === 'employer' ) {
			if ( value === 'employed' ) {
				$field.val( 'practice_lookup' );

				$form.trigger( 'practice_lookup' );
			} else if ( value === 'not_employed' ) {
				$field.val( 'personal' );

				$form.trigger( 'personal_address' );
			} else {
				$field.val( '' );

				$form.trigger( 'close_addresses' );
			}
		} else {
			$field.val( value );

			if ( value === 'practice_manual' ) {
				_show_practice_lookup_link_toggle();
			}

			$form.trigger( 'close_addresses' );
		}

		$field.trigger( 'change' );
	};

	let _toggle_address_description = function( type ) {
		let $personal = $( '#personal-address-description' ),
			$practice = $( '#practice-address-description' );

		if ( type === 'personal' ) {
			setTimeout( function() {
				$personal.fadeIn();
				$practice.fadeOut();
			}, 800 );
		} else if ( type === 'practice' ) {
			setTimeout( function() {
				$practice.fadeIn();
				$personal.fadeOut();
			}, 800 );
		} else {
			$practice.fadeOut();
			$personal.fadeOut();
		}
	};

	let _setup_practice_select_manual = function() {
		let $lookup_select = $( 'select#field_practice_lookup' );

		$lookup_select.on( 'select2:open', function( e ) {
			_attach_enter_manually_link();
		} );
	};

	let _setup_practice_address_autofill = function() {
		$form.find( 'select#field_practice_lookup' ).on( 'change', function() {
			_maybe_auto_fill_practice_address( $( this ).val() );
		} );
	};

	let _attach_enter_manually_link = function() {
		let $dropdown = $( '#field-wrap-practice_lookup' ).find( '.select2-dropdown' );

		$dropdown.prepend( $( '#practice-lookup-wrapper #enter-manually-wrapper' ) );
		$dropdown.find( '#enter-manually-wrapper' ).css( 'display', 'block' );
	};

	let _disable_address_fields = function() {
		let $practice_address_fields = $( '.practice-address-fields input' );

		// Don't set 'disabled' attribute as this prevents the other js grabbing the value - we only want them to be readonly
		$practice_address_fields.attr( 'readonly', 'readonly' );
	};

	let _enable_address_fields = function() {
		let $practice_address_fields = $( '.practice-address-fields input' );

		$practice_address_fields.attr( 'readonly', false );
	};

	let _clear_manual_address_fields = function() {
		let $name = $form.find( '#field_practice_name' ),
			$addr_line1 = $form.find( '#field_practice_address_1' ),
			$addr_line2 = $form.find( '#field_practice_address_2' ),
			$town_city = $form.find( '#field_practice_town_city' ),
			$postcode = $form.find( '#field_practice_postcode' );

		$name.val( '' );
		$addr_line1.val( '' );
		$addr_line2.val( '' );
		$town_city.val( '' );
		$postcode.val( '' );
	};

	let _maybe_auto_fill_practice_address = function( practice ) {
		let $wrapper = 	$form.find( '.practice-address-fields' ),
			$name = $form.find( '#field_practice_name' ),
			$addr_line1 = $form.find( '#field_practice_address_1' ),
			$addr_line2 = $form.find( '#field_practice_address_2' ),
			$town_city = $form.find( '#field_practice_town_city' ),
			$postcode = $form.find( '#field_practice_postcode' );

		$wrapper.loading();

		if ( ! practice ) {
			// Clear practice address values
			$name.val( '' );
			$addr_line1.val( '' );
			$addr_line2.val( '' );
			$town_city.val( '' );
			$postcode.val( '' );

			$wrapper.loaded();
		} else {
			organisations_ajax.get_singular( practice, function( response ) {
				if ( response.success ) {
					$name.val( response.organisation.name );
					$addr_line1.val( response.organisation.address_line_1 );
					$addr_line2.val( response.organisation.address_line_2 );
					$town_city.val( response.organisation.town );
					$postcode.val( response.organisation.postcode );

					$wrapper.loaded();
				} else {
					// Clear practice address values
					$name.val( '' );
					$addr_line1.val( '' );
					$addr_line2.val( '' );
					$town_city.val( '' );
					$postcode.val( '' );

					$wrapper.loaded();
				}
			} );
		}
	};

	return {
		init: init
	};

})( jQuery );

module.exports = account_details_form;